
















































import Vue from 'vue'
import {
  Configuration,
  UploadedFile,
  PositionDetail,
  PositionMeetingDetail,
  ConferenceDoctorPositionRestControllerApi,
  EntryPositionMeetingDetail,
} from '@/types/api-docs'
import FileForm from '@/components/FileForm.vue'
import PositionMeetingDetailForm from '@/components/PositionMeetingDetailForm.vue'
import attendStatus from '@/mixins/attendStatusEnum'

export interface DataType {
  pageName: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  breadcrumbs: Array<any>
  meeting?: PositionMeetingDetail
  entryMeetingAttend?: EntryPositionMeetingDetail
  positions: PositionDetail[]
  positionMeetingsId: number
  uploadedFiles?: { [p: string]: UploadedFile }
  isFormValid: boolean
}

const meetingApi = new ConferenceDoctorPositionRestControllerApi(
  new Configuration({ basePath: `${window.location.origin}` })
)

export default Vue.extend({
  mixins: [attendStatus],
  components: {
    PositionMeetingDetailForm,
    FileForm,
  },
  data(): DataType {
    return {
      pageName: this.$route.meta.title,
      breadcrumbs: [
        {
          text: 'HOME',
          href: '/member',
        },
        {
          text: '委員会一覧',
          href: '/member/positions',
        },
        {
          text: `${this.$route.meta.title}`,
          disabled: true,
        },
      ],
      meeting: undefined,
      entryMeetingAttend: undefined,
      positions: [],
      positionMeetingsId: Number(this.$route.params.id),
      uploadedFiles: undefined,
      isFormValid: true,
    }
  },
  async mounted() {
    await this.fetchMeetingDetail()
    await this.fetchMeetingFiles()
    await this.fetchEntryPositionMeetingDetail()
  },
  computed: {},
  methods: {
    async fetchMeetingDetail() {
      const { data } = await meetingApi.fetchMemberPositionMeetingDetail(this.positionMeetingsId)
      this.meeting = data
    },
    async fetchEntryPositionMeetingDetail() {
      const { data } = await meetingApi.fetchMemberEntryPositionMeetingDetail(this.positionMeetingsId)
      this.entryMeetingAttend = data
    },
    async fetchMeetingFiles() {
      const { data } = await meetingApi.fetchMemberPositionMeetingFiles(this.positionMeetingsId)
      this.uploadedFiles = data
    },
    existFile() {
      if (!this.uploadedFiles) {
        return false
      }
      for (let key of Object.keys(this.uploadedFiles)) {
        if (this.uploadedFiles[key].url) {
          return true
        }
      }
      return false
    },
  },
})
